export class VolatilityLabChartDataInputParameters {
    constructor(underlierPriceStep, underlierPricePrecision, underlierPrice, optionCalculator, seriesMapInputParameters) {
        this.seriesMapInputParameters = new Map();
        this.underlierPriceStep = underlierPriceStep;
        this.underlierPricePrecision = underlierPricePrecision;
        this.underlierPrice = underlierPrice;
        this.optionCalculator = optionCalculator;
        this.seriesMapInputParameters = seriesMapInputParameters;
    }
}
export class StrikeSeriesInfo {
    constructor(minATMStrike, maxATMStrike, strikesInfo) {
        this.minATMStrike = minATMStrike;
        this.maxATMStrike = maxATMStrike;
        this.strikesInfo = strikesInfo;
    }
}
export class StrikeInfo {
    constructor(strikePrice, callEnabled, putEnabled, callGreeks, putGreeks) {
        this.strikePrice = strikePrice;
        this.callEnabled = callEnabled;
        this.putEnabled = putEnabled;
        this.putGreeks = putGreeks;
        this.callGreeks = callGreeks;
    }
}
